<div class="file-details-dialog">
  <div class="file-details-dialog dialog">
    <div class="file-details-dialog-header dialog-header">
      <h5> {{ data?.kind === 'note' ? 'Note Details' : 'File Details' }}</h5>
      <span class="post-edit-dialog-header-close dialog-close" (click)="close()" (keypress)="close()">
        <img alt="close" [src]="'images/close.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false">
      </span>
    </div>
    <div class="dialog-content">
      <mat-dialog-content class="file-details-dialog-content dialog-content">
        <div class="file-details-dialog-subscribers-list">
          <span class="cursor-pointer">
            <table mat-table [dataSource]="ELEMENT_DATA" class="details-table"
              aria-label="Description of the data table">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Row Name</th>
                <td mat-cell *matCellDef="let element"> <b>{{ element.name }}</b></td>
              </ng-container>

              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>Value</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.name == 'Name' ) {
                    <span (click)="previewDocument()" (keypress)="previewDocument()"
                    style="color: rgb(73, 162, 221); cursor: pointer;">{{element.value}}</span>
                  }
                  @if (element.name != 'Name' ) {
                    <span>{{element.value}}</span>
                  }
                </td>
              </ng-container>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </span>
        </div>
      </mat-dialog-content>
    </div>
    <!-- <div class="file-details-dialog-footer">
    <div class="file-details-dialog-subscribers">
      <div class="left">
        <hr>
        </div>
        <div class="subscribers">Subscribers</div>
        <div class="right">
          <hr>
          </div>

        </div>
        <div class="file-details-dialog-subscribers-list">
          @for(followingUser of fileElement?.contentFollowers; track fileElement.id) {
            <span class="icon-mr-5 cursor-pointer" [matTooltip]="followingUser.userName">
              <img [src]="followingUser.profilePictureUrl" alt="user icon" class="user-img" />
            </span>
          }
        </div>
        <div class="file-details-dialog-subscribers-text">
          @if(fileElement.contentFollowers?.length > 0) {
            <p> {{ currentUserSubscribed ? 'You and ' : '' }} {{ (currentUserSubscribed && fileElement.contentFollowers?.length > 1 ) ? fileElement.contentFollowers?.length - 1 : ''}} person will be notified when someone updates or comments on this {{fileElement.kind}}.
              <span (click)="subscribeCall()" style="color: rgb(73, 162, 221); cursor: pointer;">{{subscribe}}</span>
            </p>
          }
          @else{
          <p>You’ll get a notification when someone updates or comments on this {{fileElement.kind}}.
            <span (click)="subscribeCall()" style="color: rgb(73, 162, 221); cursor: pointer;">{{subscribe}}</span>
          </p>
        }
      </div>
    </div> -->
  </div>
</div>
@if (previewElement) {
  <collaboration-ui-doc-viewer [document]="previewElement" (onPreviewClose)="onPreviewClose()">
</collaboration-ui-doc-viewer>
}